<template>
    <b-card>

        <b-card header="Hábitos">
            <b-form @submit.stop.prevent="onSubmit">

            <div class="animated fadeIn">

                <b-row>
                <b-col md="4">
                    <b-form>
                    <input id="smoker" type="checkbox" value="test" v-model="currentItem.smoker"> Fumante
                    </b-form>
                </b-col>
                <b-col md="4">
                    <b-form>
                    <input id="alcoholic" type="checkbox" value="test" v-model="currentItem.alcoholic"> Alcoolismo
                    </b-form>
                </b-col>
            
                </b-row>

            
            </div>
            </b-form>
        </b-card>

        <b-card header="Pessoa com Deficiência">
            <b-form @submit.stop.prevent="onSubmit">

            <div class="animated fadeIn">

                <b-row>
                <b-col md="4">
                    <b-form>
                    <input id="specialNeed" type="checkbox" value="test" v-model="currentItem.specialNeed"> Necessidades especiais
                    </b-form>
                </b-col>
            
                </b-row>

                <hr>

                <b-row>
                <b-col md="4">
                    <b-form>
                    <input id="blind" type="checkbox" value="test" v-model="currentItem.blind"> Deficiência visual / cego
                    </b-form>
                    </b-col>
                <b-col md="4">
                    <b-form>
                    <input id="deaf" type="checkbox" value="test" v-model="currentItem.deaf"> Deficiência auditiva / surdo
                    </b-form>
                    </b-col>
                <b-col md="4">
                    <b-form>
                    <input id="dumb" type="checkbox" value="test" v-model="currentItem.dumb"> Mudo
                    </b-form>
                    </b-col>
                </b-row>

            
            </div>
            </b-form>
        </b-card>

        <b-card header="Histórico Médico / Familiar">
            <b-form @submit.stop.prevent="onSubmit">

            <div class="animated fadeIn">

                <b-row>
                <b-col md="4">
                    <b-form>
                    <input id="highBloodPressure" type="checkbox" value="test" v-model="currentItem.highBooldPressure" true-value=true false-value=false> Pressão alta
                    </b-form>
                    </b-col>
                <b-col md="4">
                    <b-form>
                    <input id="cancer" type="checkbox" value="test" v-model="currentItem.cancer" true-value=true false-value=false> Câncer
                    </b-form>
                    </b-col>
                <b-col md="4">
                    <b-form>
                    <input id="cancerFamilyHistory" type="checkbox" value="test" v-model="currentItem.cancerFamilyHistory" true-value=true false-value=false> Câncer (Histórico Familiar)
                    </b-form>
                    </b-col>
                </b-row>

                <b-row>
                <b-col md="4">
                    <b-form>
                    
                    </b-form>
                </b-col>
                <b-col md="4">
                    <b-form>
                    <b-form-input v-model="currentItem.cancerType" id="cancerType" type="text"></b-form-input>
                    </b-form>
                </b-col>
                <b-col md="4">
                    <b-form>
                    <b-form-input v-model="currentItem.cancerFamilyHistoryType" id="cancerFamilyHistoryType" type="text"></b-form-input>
                    </b-form>
                </b-col>
                </b-row>


                <b-row>
                <b-col md="12">
                <b-form>
                    <div>
                    <b-form-group
                        label="Observações"
                        label-for="notes"
                        description="Dados sigilosos"
                        >
                        <b-form-textarea
                        id="notes"
                        v-model="currentItem.notes"
                        placeholder=""
                        rows="3"
                        ></b-form-textarea>
                        </b-form-group>
                    </div>
                
                </b-form>
                </b-col>
            </b-row>


            </div>
            </b-form>
        </b-card>


        <b-input-group class="mb-4">
            <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
        </b-input-group>

        <div slot="footer" class="text-right">
            <b-button variant="github" class="mr-1 btn-brand" @click="saveItem()"><i class="fa fa-check"></i><span>Salvar Dados Médicos</span></b-button>
        </div>

    </b-card>
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
    import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
    //import { table } from 'console'
    
    const toastTypes = {
      success: 'success',
      error: 'error',
      info: 'info',
      warn: 'warn'
    }
    
    miniToastr.init({types: toastTypes})
    
    function toast ({title, message, type, timeout, cb}) {
      return miniToastr[type](message, title, timeout, cb)
    }
    
    const options = {
      success: toast,
      error: toast,
      info: toast,
      warn: toast
    }
    VueNotifications.setPluginOptions(options)
    
    Vue.use(VueNotifications, options)
    /* Toast - End */
  
    export default {
      name: 'PersonMedicalDataComponent',
      props: {
         item: {}
      },
      computed: {
          selectedItem() {
              return this.item
          }
      },
      components: {
      },
      data: () => {
          return {
            currentItem: {},
            errorMessage: ''
          }
      },
      methods: {
        async saveItem() {
          var s = this;
          var currentUser = this.$store.state.currentUser
          this.currentItem.id = this.selectedItem.id
          this.currentItem.uid = currentUser.id
          this.currentItem.sid = currentUser.sid

          await axios.post(
              this.$store.state.ws_url + "/person/medicaldata",
              this.currentItem
          ).then(function() {

            toast ({
              type: VueNotifications.types.success,
              title: 'Dados Médicos',
              message: 'Dados médicos salvos com sucesso.',
              timeout: 5000
            })

          }).catch(function (error) {
            console.log(error);

            toast ({
              type: VueNotifications.types.error,
              title: 'Dados Médicos',
              message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
              timeout: 5000
            })
            
          });

        }
      },
      mounted: function() {
        this.currentItem = (this.selectedItem.medicalData ? this.selectedItem.medicalData : {})
      }
    }
  
  </script>